import React from 'react';
import { Page } from '../Page';
import { Heart, Activity, ShieldPlus, Apple } from 'lucide-react';
import { SupplementCallout } from '../SupplementCallout';
export function Page8() {
  return <Page pageNumber={19} variant="light" data-id="element-1072" data-mp="2vsl8q2u9kcjs">
      <div className="flex flex-col h-full" data-id="element-1073" data-mp="2vtmk68f6z121">
        <div className="h-[180px] -mx-12 -mt-10 mb-8 overflow-hidden relative" data-id="element-1074" data-mp="2r1mr8zxjh8ey">
          <img src="https://images.unsplash.com/photo-1610348725531-843dff563e2c?w=1000&q=80" alt="Colorful high-fiber vegetables and fruits" className="w-full h-full object-cover" data-id="element-1075" data-mp="2qziaviigegxs" />
          <div className="absolute inset-0 bg-gradient-to-t from-[#F5F5F0] via-[#F5F5F0]/40 to-transparent" data-id="element-1076" data-mp="3erh0l7ingeug" />
        </div>

        <div className="mb-6 pt-0" data-id="element-1077" data-mp="39t5sp2bx0eev">
          <p className="text-[10px] font-bold text-tealslate uppercase tracking-[0.2em] mb-3" data-id="element-1078" data-mp="39prs9zmtafa2">
            The Essentials
          </p>
          <h1 className="text-5xl font-serif text-[#1F1F1F] leading-tight mb-4" data-id="element-1079" data-mp="1fecx33b17nmx">
            <span className="text-tealslate" data-id="element-1080" data-mp="2nqi5zx74aqk0">Fiber</span>
          </h1>
          <div className="w-16 h-0.5 bg-tealslate" data-id="element-1081" data-mp="2nof8yt7jrx5s" />
        </div>

        <div className="grid grid-cols-2 gap-10 mb-8" data-id="element-1082" data-mp="2rt52ibeqgznj">
          <p className="text-sm text-[#3B3B3B] leading-[1.8]" data-id="element-1083" data-mp="2wr6pv8j6zl4t">
            GLP-1 medications slow down your digestion. While this keeps you
            full, it also creates the most common side effect: constipation.
            Fiber is your primary defense.
          </p>
          <div className="bg-[#EAEAE4] border border-[#D8D8D0] p-5" data-id="element-1084" data-mp="36j40oe6agb30">
            <h3 className="text-xs font-bold text-tealslate uppercase tracking-wider mb-3" data-id="element-1085" data-mp="3berq8uoon691">
              Recommended Daily Intake
            </h3>
            <div className="flex gap-8" data-id="element-1086" data-mp="3kgslxn49pk8l">
              <div data-id="element-1087" data-mp="3kfpv1f6y3hso">
                <span className="text-3xl font-serif text-tealslate" data-id="element-1088" data-mp="3kg9406emavuk">25g</span>
                <span className="text-xs text-[#7A7A70] ml-2" data-id="element-1089" data-mp="1l4q4sjj491y3">women</span>
              </div>
              <div data-id="element-1090" data-mp="1q1yh43hl2brf">
                <span className="text-3xl font-serif text-tealslate" data-id="element-1091" data-mp="1q39t2ql6mptm">38g</span>
                <span className="text-xs text-[#7A7A70] ml-2" data-id="element-1092" data-mp="2teoy9fq6qtu4">men</span>
              </div>
            </div>
          </div>
        </div>

        <h2 className="text-lg font-serif text-[#1F1F1F] mb-4" data-id="element-1093" data-mp="2ogf5fbrxo5bo">
          Great Food Sources
        </h2>
        <div className="flex flex-wrap gap-2 mb-8" data-id="element-1094" data-mp="32c928wffn48f">
          {['Beans', 'Lentils', 'Broccoli', 'Berries', 'Oats', 'Chia Seeds', 'Avocado', 'Apples', 'Brussels Sprouts'].map((item, i) => <div key={i} className="bg-[#EAEAE4] border border-[#D8D8D0] px-4 py-2 text-xs text-[#1F1F1F] font-medium flex items-center gap-2" data-id="element-1095" data-mp="3l4trm3vxar7h" data-mpi={i}>
              <Apple className="w-3 h-3 text-tealslate" data-id="element-1096" data-mp="3h5cj11l79dy3" />
              {item}
            </div>)}
        </div>

        <div className="grid grid-cols-4 gap-4 mb-6" data-id="element-1097" data-mp="3q46dalb25s8h">
          {[{
          icon: ShieldPlus,
          label: 'Gut Health'
        }, {
          icon: Activity,
          label: 'Blood Sugar'
        }, {
          icon: Apple,
          label: 'Satiety'
        }, {
          icon: Heart,
          label: 'Heart Health'
        }].map((item, i) => <div key={i} className="text-center" data-id="element-1098" data-mp="8nbuqtqw16nv" data-mpi={i}>
              <div className="w-10 h-10 rounded-full bg-tealslate/20 border border-tealslate/40 flex items-center justify-center mx-auto mb-2" data-id="element-1099" data-mp="3qyyjwgvthrhf">
                <item.icon className="w-5 h-5 text-tealslate" data-id="element-1100" data-mp="3vs1hr17mnn3f" />
              </div>
              <span className="text-[10px] font-bold text-[#1F1F1F] uppercase tracking-wider" data-id="element-1101" data-mp="3h2luvwb7w1t0">
                {item.label}
              </span>
            </div>)}
        </div>

        <SupplementCallout title="Fiber Supplement" description="Inulin fiber is a well-tolerated option for increasing daily intake. Take it with meals to improve absorption." data-id="element-1102" data-mp="381nlszlx943k" />
      </div>
    </Page>;
}